import { ApiEndpoint } from "../types/ApiTypes";

export const SmsApi: Record<string, ApiEndpoint> = {
    RequestVerification: {
        title: "SMS 인증번호 요청",
        method: "POST",
        url: "/Sms/RequestVerification",
    },
    VerifyCode: {
        title: "SMS 인증번호 확인",
        method: "POST",
        url: "/Sms/VerifyCode",
    },
    SendTest: {
        title: "SMS 발송 테스트",
        method: "POST",
        url: "/Sms/SendTest",
    },
    GetHistory: {
        title: "SMS 발송 내역 조회",
        method: "GET",
        url: "/Sms/History",
    },
};
